import React from 'react'

function About() {
    return (
        <section className="about-section py-5" >
            <div className="container" >
                {/* Title */}
                <div className="text-center mb-5">
                    <h2 className="fw-bold">About Tamil Nadu Warehousing</h2>
                    <p className="text-muted mt-2">
                        Strengthening storage, supply chains, and economic growth
                    </p>
                </div>

                <div className="row align-items-center g-5">
                    {/* LEFT CONTENT */}
                    <div className="col-md-6" data-aos="fade-right">
                        <h4 className="fw-semibold mb-3">
                            Reliable & Strategic Warehousing Solutions
                        </h4>
                        <p className="text-muted">
                            Tamil Nadu Warehousing Corporation (TNWC) plays a vital role in
                            strengthening the agricultural and industrial backbone of the
                            state. With a widespread network of strategically located
                            warehouses, we ensure safe, secure, and efficient storage of
                            commodities.
                        </p>
                        <p className="text-muted">
                            Our warehouses are equipped with modern infrastructure, advanced
                            inventory management systems, and quality control measures to
                            reduce post-harvest losses and improve supply chain efficiency.
                        </p>

                        {/* FEATURES */}
                        <div className="row mt-4" data-aos="zoom-in" data-aos-delay="90000" >
                            {[
                                'Modern Storage Infrastructure',
                                'Cold & Dry Storage Facilities',
                                'Strategic Locations Across Tamil Nadu',
                                'Secure & Insured Warehouses',
                            ].map((item, idx) => (
                                <div key={idx} className="col-6 mb-3">
                                    <div className="about-feature1">
                                        <span>✔</span> {item}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* RIGHT CARDS */}
                    <div className="col-md-6" data-aos="fade-left" data-aos-delay="200">
                        <div className="row g-4">
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>50+</h3>
                                    <p>Warehouses</p>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>10L+</h3>
                                    <p>MT Storage Capacity</p>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>24/7</h3>
                                    <p>Security & Monitoring</p>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>100%</h3>
                                    <p>Quality Assurance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About